import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import isArray from "lodash/isArray";
import once from "lodash/once";
import { action, computed, observable } from "mobx";
export var FormField = /*#__PURE__*/ function() {
    "use strict";
    function FormField(value, eventName, validator) {
        var _this = this;
        var eventPrefix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "sign-up";
        var _this1 = this;
        _class_call_check(this, FormField);
        this.validator = validator;
        this.eventPrefix = eventPrefix;
        this.firstChangeEvent = once(function() {
            var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            return trackEvent("/open/".concat(_this1.eventPrefix, "/change/").concat(_this1.eventName).concat(query));
        });
        this.selectValue = function(value) {
            _this.firstChangeEvent();
            _this.value = value;
            _this.error = undefined;
        };
        this.setValue = function(_name, value) {
            _this.selectValue(value);
        };
        this.resetValue = function(value) {
            _this.value = value;
            _this.error = undefined;
        };
        this.setError = function(error) {
            _this.error = error ? error : undefined;
        };
        makeObservable(this);
        this.value = value;
        this.eventName = eventName;
        var shouldFireEvent = isArray(value) ? value.length !== 0 : value;
        if (shouldFireEvent) {
            this.firstChangeEvent("?prefill=true");
        }
    }
    _create_class(FormField, [
        {
            key: "isInvalid",
            get: function get() {
                return this.validator(this.value);
            }
        }
    ]);
    return FormField;
}();
__decorate([
    observable
], FormField.prototype, "value", void 0);
__decorate([
    observable
], FormField.prototype, "error", void 0);
__decorate([
    computed
], FormField.prototype, "isInvalid", null);
__decorate([
    action
], FormField.prototype, "selectValue", void 0);
__decorate([
    action
], FormField.prototype, "setValue", void 0);
__decorate([
    action
], FormField.prototype, "resetValue", void 0);
__decorate([
    action
], FormField.prototype, "setError", void 0);
